import initialState from './../initialState';

const reducers = {
    LOAD_ESTABLISHMENT_USERS_SUCCESS: (state, payload) => {
      return payload;
    }
};

export default function establishmentUsers(state = initialState.establishmentUsers, action) {
    let reducer = reducers[action.type];
    return (reducer ? reducer(state, action.establishmentUsers) : state);
  }


/** WEBPACK FOOTER **
 ** ./src/reducers/establishment/establishmentUserReducer.js
 **/